'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { OLAF, OZ, CANDY_APPLE_DARK, MARIGOLD } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';

const CompatibilityIcon = (_ref) => {
  let {
    compatible,
    partial
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["compatible", "partial"]);

  let backgroundColor;

  if (!compatible) {
    backgroundColor = CANDY_APPLE_DARK;
  } else if (partial) {
    backgroundColor = MARIGOLD;
  } else {
    backgroundColor = OZ;
  }

  return /*#__PURE__*/_jsx(UIIconCircle, Object.assign({
    name: compatible ? 'success' : 'remove',
    color: OLAF,
    backgroundColor: backgroundColor,
    borderWidth: 0,
    padding: 0.25,
    size: 8,
    style: {
      position: 'relative',
      top: -2
    }
  }, rest));
};

CompatibilityIcon.propTypes = {
  compatible: PropTypes.bool,
  partial: PropTypes.bool
};
export default CompatibilityIcon;